import toastr from 'toastr';
import Translator from 'translator';
import Logger from 'data/common/Logger';

toastr.options = {
    closeButton: false,
    tapToDismiss: true,
    debug: false,
    newestOnTop: false,
    positionClass: 'toast-top-right',
    onclick: null,

    showDuration: 300,
    hideDuration: 300,
    closeEasing: 'linear',

    showMethod: 'slideDown',
    hideMethod: 'slideUp',
    closeMethod: 'slideUp',

    preventDuplicates: true,

    timeOut: 15000, // How long the toast will display without user interaction

    progressBar: true
};

export default {
    clear: toastr.clear,
    remove: toastr.remove,
    persistentError: (error, title) => {
        const options = {
            timeOut: 0,
            extendedTimeOut: 0,
            progressBar: false
        };
        toastr.error(error, title, options);
    },
    error: (_error, title, options) => {
        let error = _error;
        if (__DEV__) Logger.error('Snackbar Error : ', error);
        if (typeof error === 'object' && error.message) {
            error = Translator.translate(error.message);
        } else if (typeof error === 'object' && error.data && error.data.errors) {
            error = Translator.translate(error.data.errors[0].message);
        } else if (typeof error !== 'string') {
            return false;
        }

        return toastr.error(error, title, options);
    },
    success: toastr.success,
    warning: toastr.warning,
    info: toastr.info,
    confirm: (message, _title, _object) => {
        let object = _object;
        let title = _title;
        const options = {
            timeOut: 0, // How long the toast will display without user interaction
            extendedTimeOut: 0, // How long the toast will display after a user hovers over it
            progressBar: false,
            tapToDismiss: false
        };

        if (typeof title !== 'string') {
            object = title;
            title = undefined;
        } else if (typeof object === 'undefined') {
            object = {};
        }

        const uniqID = Math.floor(Math.random() * 111111111);

        let messageHTML = '<div>';
        messageHTML += message;
        messageHTML += '<br />';
        messageHTML += '<div class="text-right mt-3">';
        messageHTML += `<button class="btn btn-sm mr-2 bg-transparent text-success font-weight-bold" id="btn_yes_${uniqID}">Oui</button>`;
        messageHTML += `<button class="btn btn-sm bg-transparent text-danger font-weight-bold" id="btn_no_${uniqID}">Non</button>`;
        messageHTML += '</div>';
        messageHTML += '</div>';

        if (title) toastr.info(messageHTML, title, options);
        else toastr.info(messageHTML, null, options);

        Logger.log(toastr);
        document.getElementById(`btn_yes_${uniqID}`).addEventListener('click', e => {
            e.stopPropagation();
            if (typeof object.onYes === 'function') {
                object.onYes();
            }
            document.getElementById(`btn_yes_${uniqID}`).closest('.toast').className += ' animated fadeOutDown';
            setTimeout(() => {
                document
                    .getElementById(`btn_yes_${uniqID}`)
                    .closest('.toast')
                    .remove();
            }, 1000);
        });

        document.getElementById(`btn_no_${uniqID}`).addEventListener('click', e => {
            e.stopPropagation();
            if (typeof object.onNo === 'function') {
                object.onNo();
            }
            document.getElementById(`btn_no_${uniqID}`).closest('.toast').className += ' animated fadeOutDown';
            setTimeout(() => {
                document
                    .getElementById(`btn_no_${uniqID}`)
                    .closest('.toast')
                    .remove();
            }, 1000);
        });
    },
    select: (message, _title, _list, _object) => {
        let object = _object;
        let title = _title;
        let list = _list;

        const options = {
            timeOut: 0, // How long the toast will display without user interaction
            extendedTimeOut: 0, // How long the toast will display after a user hovers over it
            progressBar: false,
            tapToDismiss: false
        };

        if (typeof title !== 'string') {
            object = title;
            title = undefined;
        } else if (typeof object === 'undefined') {
            object = {};
        }

        const uniqID = Math.floor(Math.random() * 111111111);

        const cancel = Translator.translate('general.cancel');

        let messageHTML = '<div>';
        messageHTML += message;
        messageHTML += '<br />';
        messageHTML += '<br />';
        list.forEach(data => {
            messageHTML += `<div class="toastrList" value=${data.id} id="btn_yes_${data.id}"> ${data.label}</div>`;
        });
        messageHTML += '<div class="text-right mt-3">';
        messageHTML += `<button class="btn btn-sm bg-transparent text-danger font-weight-bold" id="btn_no_${uniqID}">${cancel}</button>`;
        messageHTML += '</div>';
        messageHTML += '</div>';

        if (title) toastr.info(messageHTML, title, options);
        else toastr.info(messageHTML, null, options);

        Logger.log(toastr);

        list.forEach(data => {
            document.getElementById(`btn_yes_${data.id}`).addEventListener('click', e => {
                e.stopPropagation();
                if (typeof object.onYes === 'function') {
                    object.onYes(`${data.id}`);
                }
                document.getElementById(`btn_yes_${data.id}`).closest('.toast').className += ' animated fadeOutDown';
                setTimeout(() => {
                    document
                        .getElementById(`btn_yes_${data.id}`)
                        .closest('.toast')
                        .remove();
                }, 1000);
            });
        });

        document.getElementById(`btn_no_${uniqID}`).addEventListener('click', e => {
            e.stopPropagation();
            if (typeof object.onNo === 'function') {
                object.onNo();
            }
            document.getElementById(`btn_no_${uniqID}`).closest('.toast').className += ' animated fadeOutDown';
            setTimeout(() => {
                document
                    .getElementById(`btn_no_${uniqID}`)
                    .closest('.toast')
                    .remove();
            }, 1000);
        });
    },
    notice: ({ content, title, onClick }) => {
        const options = {
            timeOut: 0,
            extendedTimeOut: 0,
            progressBar: false,
            onHidden: onClick,
            closeButton: true
        };
        toastr.warning(content, title, options);
        Logger.log(toastr);
    }
};



// WEBPACK FOOTER //
// ./data/common/Toastr.js